import { Routes } from '@angular/router';
import { PageNotFoundPageComponent } from './modules/page-not-found-page/page-not-found-page.component';

export const AppRoutes: Routes = [
  {
    path: '',
    loadChildren: () => import('@app/layouts/main/main.routes').then((m) => m.MAIN_ROUTES),
  },
  {
    path: 'home',
    loadComponent: () => import('@app/modules/home-page/home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: 'external:cc',
    loadComponent: () =>
      import('./modules/external/components/shared-form/shared-form.component').then((m) => m.SharedFormComponent),
  },
  {
    path: '404',
    component: PageNotFoundPageComponent,
  },
  { path: '**', component: PageNotFoundPageComponent },
];
